var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view_list-24px",
    width: 16,
    height: 14,
    viewBox: "0 0 30 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M10.048,14H23.381c.733,0,1.333-.45,1.333-1V11c0-.55-.6-1-1.333-1H10.048c-.733,0-1.333.45-1.333,1v2C8.714,13.55,9.314,14,10.048,14Zm0,5H23.381c.733,0,1.333-.45,1.333-1V16c0-.55-.6-1-1.333-1H10.048c-.733,0-1.333.45-1.333,1v2C8.714,18.55,9.314,19,10.048,19ZM8.714,6V8c0,.55.6,1,1.333,1H23.381c.733,0,1.333-.45,1.333-1V6c0-.55-.6-1-1.333-1H10.048C9.314,5,8.714,5.45,8.714,6Z",
    transform: "translate(-4.542 -0.316)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.1b57dca1.svg";
export { ForwardRef as ReactComponent };